
import React from 'react';

const AccountError = ({...props}) => (
  <svg viewBox="0 0 14 14">
    <g id="B2B-Flow---Terms-Client-Error" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="d---account-error" transform="translate(-978.000000, -23.000000)">
        <g id="Group-2-Copy-3" transform="translate(978.000000, 23.000000)">
          <rect id="Rectangle" fill={props.fill || '#FF3A3A'} x="0" y="0" width="14" height="14" rx="7"></rect>
          <path d="M7.42421028,7.70842038 L7.6894734,4.63578924 L7.75578918,3 L5.85473682,3 L5.9210526,4.63578924 L6.18631572,7.70842038 L7.42421028,7.70842038 Z M6.805263,10.5378937 C7.44631554,10.5378937 7.910526,10.0294727 7.910526,9.38842014 C7.910526,8.7473676 7.44631554,8.23894662 6.805263,8.23894662 C6.16421046,8.23894662 5.7,8.7473676 5.7,9.38842014 C5.7,10.0294727 6.16421046,10.5378937 6.805263,10.5378937 Z" id="!" fill="#FFFFFF" fill-rule="nonzero"></path>
        </g>
      </g>
    </g>
  </svg>
);

export default AccountError;
